import {
  Box,
  Button,
  Flex,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { api } from '../../../../services/api'
import { BsFillCameraFill } from 'react-icons/bs'

export function Modal({ formState, errors, watchFields, getDadosCanhoto }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [image, setImage] = useState(null)

  const videoRef = useRef(null)
  const canvasRef = useRef(null)

  function openModal() {
    if (formState.isSubmitting) return

    if (!errors?.pedido) {
      onOpen()
    }
  }

  const toast = useToast({
    position: 'top',
  })

  const [loadingUploadImage, setLoadingUploadImage] = useState(false)

  async function handleInfoImage() {
    setLoadingUploadImage(true)

    const blob = dataURItoBlob(image)
    const file = new File([blob], 'captured_image.png', { type: 'image/png' })

    const formData = new FormData()
    formData.append('imagem', file)
    formData.append('numero_pedido', watchFields[0])

    try {
      const response = await api.post(
        '/site/v2/organiza-canhoto/envia-dados-canhoto',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      console.log('response', response)

      toast({
        title: 'Imagem enviada com sucesso',
        status: 'success',
        duration: 9000,
        isClosable: true,
      })

      onClose()
      getDadosCanhoto()
    } catch (error) {
      console.error('Error validating innovation:', error)
      toast({
        title: 'Erro ao enviar imagem',
        description: `${JSON.stringify(error.response.data)}`,
        status: 'error',
        duration: 9000,
        isClosable: true,
      })

      setLoadingUploadImage(false)
    }

    setLoadingUploadImage(false)
  }

  useEffect(() => {
    setImage(null)
  }, [isOpen])

  const constraints = {
    video: {
      facingMode: { exact: 'environment' }, // "environment" para câmera traseira
    },
  }

  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints)
      videoRef.current.srcObject = stream
    } catch (error) {
      console.error('Error accessing camera:', error)
    }
  }

  function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: mimeString })
  }

  const captureImage = async () => {
    const video = videoRef.current
    const canvas = canvasRef.current
    const context = canvas.getContext('2d')

    context.drawImage(video, 0, 0, canvas.width, canvas.height)
    const image = canvas.toDataURL('image/png')

    setImage(image)
  }

  useEffect(() => {
    if (isOpen) {
      openCamera()
    }
  }, [isOpen])

  return (
    <>
      <Button
        onClick={openModal}
        colorScheme="blue"
        width="200px"
        size="md"
        isLoading={formState.isSubmitting}
        type="submit"
      >
        Salvar canhoto
      </Button>
      <ChakraModal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Foto do canhoto</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              {!image ? (
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                >
                  <video
                    ref={videoRef}
                    width={1200}
                    height={600}
                    playsInline
                    autoPlay
                    muted
                    style={{ transform: 'scaleX(-1)' }}
                  />
                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                </Flex>
              ) : (
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                >
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => setImage(null)}
                    position="absolute"
                    top={3}
                    right={0}
                  >
                    Tirar outra foto
                  </Button>

                  <img src={image} alt="Captured" width={1200} height={600} />
                </Flex>
              )}

              <></>
            </div>
          </ModalBody>

          <ModalFooter
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDir={'column'}
          >
            <div>
              <Box
                align="center"
                gap={2}
                onClick={captureImage}
                cursor="pointer"
                p={2}
                bg="#378BBF"
                borderRadius="md"
              >
                <BsFillCameraFill size={30} color="white" />
              </Box>

              {/* <Button
                onClick={captureImage}
                colorScheme="blue"
                mt={2}
                display="block"
                margin="1rem auto"
                isLoading={formState.isSubmitting}
              >
                Tirar foto
              </Button> */}
            </div>

            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleInfoImage}
              alignSelf="flex-end"
              mt={2}
              isLoading={loadingUploadImage}
            >
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  )
}
